"use strict";
/** Ανοιχτές εργασίες CRM — κοινό web & mobile */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOpenTaskOverdue = isOpenTaskOverdue;
exports.sortOpenTasks = sortOpenTasks;
function isOpenTaskOverdue(task, now = new Date()) {
    if (task.status !== 'OPEN')
        return false;
    if (!task.dueAt)
        return false;
    return new Date(task.dueAt).getTime() < now.getTime();
}
function sortOpenTasks(tasks) {
    return [...tasks]
        .filter((t) => t.status === 'OPEN')
        .sort((a, b) => {
        const aOver = isOpenTaskOverdue(a);
        const bOver = isOpenTaskOverdue(b);
        if (aOver !== bOver)
            return aOver ? -1 : 1;
        const aDue = a.dueAt ? new Date(a.dueAt).getTime() : Number.POSITIVE_INFINITY;
        const bDue = b.dueAt ? new Date(b.dueAt).getTime() : Number.POSITIVE_INFINITY;
        if (aDue !== bDue)
            return aDue - bDue;
        return a.title.localeCompare(b.title, 'el');
    });
}
